import { Icon } from "@clarkinc/zest-design-system/ui";
import React from "react";
interface HeaderProps {
  onClose: () => void;
}
const Header = ({
  onClose
}: HeaderProps) => {
  const undoScreenReaderOnlyClasses = "lm:static lm:w-auto lm:h-auto lm:overflow-visible lm:clip-auto lm:whitespace-normal lm:p-0 lm:m-0";
  return <div className="bg-blue-900 flex items-start px-6 pb-6 pt-8 xs:p-10 mt-0 rounded-none lm:p-0 lm:border-b-0 lm:w-[535px]" data-sentry-component="Header" data-sentry-source-file="Header.tsx">
      <button type="button" className="plus-subscription-modal absolute right-0 appearance-none bg-transparent border-none m-0 p-0 rounded mr-4 mt-2 z-10 top-2 opacity-100 hover:opacity-50 lm:font-normal" data-testid="closeButton" aria-label="Close" onClick={onClose}>
        <Icon name="ri-close-line" theme="wss" size="small" className="fill-white" data-sentry-element="Icon" data-sentry-source-file="Header.tsx" />
      </button>
      <div className="visible lm:invisible lm:w-0">
        <figure data-testid="modalImage">
          <source media="(min-width: 980px)" srcSet="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-benefits-v2.svg" />
          <img src="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-benefits-v2.svg" alt="" />
          <figcaption className="sr-only" data-sentry-element="figcaption" data-sentry-source-file="Header.tsx">
            <h2>Webstaurant Plus</h2>
            <p>
              Unlimited free shipping, expedited order processing, and a savings
              guarantee. All for just $99/month.
            </p>
            <p>Free Shipping</p>
            <p>Guaranteed Savings</p>
            <p>Get your items faster</p>
          </figcaption>
        </figure>
      </div>
      <div className="flex flex-col w-0 h-0 invisible lm:visible lm:py-16 lm:px-12 lm:w-auto lm:h-auto">
        <figure data-testid="modalImage">
          <source media="(min-width: 980px)" srcSet="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-testimonial-image-v2.png" />
          <img src="//cdnimg.webstaurantstore.com/uploads/design/2024/6/PlusPage/plus-marketing-testimonial-image-v2.png" alt="" />
          <figcaption className="sr-only" data-sentry-element="figcaption" data-sentry-source-file="Header.tsx">
            <h2>Webstaurant Plus</h2>
            <p>
              Unlimited free shipping, expedited order processing, and a savings
              guarantee. All for just $99/month.
            </p>
            <blockquote>
              “The Plus program is saving us a ton of money. At $99 a month, it
              paid for itself in literally the first week we had it.”
            </blockquote>
            <cite>— John S. of John Serock Catering</cite>
          </figcaption>
        </figure>

        <p className={`sr-only ${undoScreenReaderOnlyClasses} text-xs font-normal text-blue-50 pt-6`}>
          Special offers only valid for first time subscribers. This program
          only allows for a single shipping address and may be updated once per
          payment cycle if benefit is unused. Enrollment is open only to
          addresses located in the 48 contiguous United States. WebstaurantStore
          reserves the right to modify the terms of this program and to cancel
          this program at any time.
        </p>
      </div>
    </div>;
};
export default Header;